import type { ClassValue } from 'clsx'
import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]): string {
  // TODO: Implement presetUno merge
  // eg: return unoMerge(clsx(inputs))
  return twMerge(clsx(inputs))
}
